<app-header (hamburgerClick)="drawer.toggle()"></app-header>
<app-template-ref></app-template-ref>
<mat-drawer-container>
  <mat-drawer #drawer mode="over" class="main-menu">
  </mat-drawer>
  <mat-drawer-content [ngStyle]="{'height': height + 'px'}">
    <mat-drawer-container [ngStyle]="{'height': height + 'px'}">
      <mat-drawer mode="side" opened [ngClass]="{'full': hover, 'small no-scroll-bar': !hover}" class="drawer"
                  (mouseover)="hover=true;" (mouseleave)="hover=false;"
                  *ngIf="currentRootRoute !== 'auth'">
        <app-side-menu></app-side-menu>
      </mat-drawer>
      <router-outlet></router-outlet>
    </mat-drawer-container>
  </mat-drawer-content>
</mat-drawer-container>
